// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__1dt7U","content":"ManualTimeModal_content__2NXGp"};